import instanceTMS from '../apiClevertms';
import { message } from 'antd';

interface Field {
  id: boolean;
  city: boolean;
  state: boolean;
  lat: number;
  lng: number;
  zips: boolean;
  timezone: boolean;
  updatedAt: boolean;
  createAt: boolean;
  isActive: boolean;
}

export const cityController = {
  async read(city: any) {
    let query: any = {
      limit: 100,
      where: {
        and: [
          {
            city: { ilike: `%${city}%` },
          },
        ],
      },
    };
    const { data }: { data: object } = await instanceTMS(
      `admin/cities?filter=${encodeURIComponent(JSON.stringify({ ...query }))}`,
    );
    const getCount = async () => {
      return 0;
    };
    const count = await getCount();

    return { data, count: count };
  },

  async cityCompanyOne(companyId: string | number | undefined) {
    const { data }: { data: any } = await instanceTMS(`admin/cities/${companyId}`);

    return data;
  },

  async cityPatch(companyData: Field) {
    const { id, ...rest } = companyData;
    const key = 'updatable';
    message.loading({ content: 'Loading...', key });
    const { data }: { data: any } = await instanceTMS(`admin/cities/${id}`, {
      method: 'PATCH',
      data: rest,
    }).then((u) => {
      setTimeout(() => {
        message.success({ content: 'Loaded!', key, duration: 2 });
      }, 1000);
      return u;
    });
    return data;
  },

  async addCityController(companyId: any) {
    message.loading({ content: 'Loading...', key: companyId });
    const { data } = await instanceTMS('admin/cities/', {
      method: 'POST',
      data: {
        ...companyId,
      },
    }).then((u) => {
      setTimeout(() => {
        message.success({ content: 'Loaded!', key: companyId, duration: 2 });
      }, 1000);
      return u;
    });
    return data;
  },
  async deleteCityController(id: number | string) {
    message.loading({ content: 'Loading...', key: id });
    let res;
    let error = '';
    try {
      const { data } = await instanceTMS(`admin/cities/${id}`, {
        method: 'DELETE',
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Deleted!', key: id, duration: 2 });
        }, 1000);
        return u;
      });
      res = data;
    } catch (err) {
      error = 'Oops something went wrong!';
    }
    return { data: res, error };
  },

  async companyFinderId(city: any) {
    let query: any = {
      // "limit": 100,
      where: {
        and: [{ city: { ilike: `%${city}%` } }],
      },
    };
    const { data }: { data: Array<any> } = await instanceTMS(
      `admin/cities?filter=${encodeURIComponent(JSON.stringify({ ...query }))}`,
    );
    return data;
  },
};
